module.exports = __webpack_public_path__ + "static/media/direct-mail-hover.528daa4c.svg";